import NominatedRewardsContainer from './container/NominatedRewardsContainer';
import { useSelector } from 'react-redux';
import { Spinner } from '../_shared/index.js';

export const NominatedRewards = () => {
	const company = useSelector((state) => state.user.currentUser.company);
	if (!company) return <Spinner />;
	return <NominatedRewardsContainer />;
};

export default NominatedRewards;
